var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"问题定位","width":"800px","visible":_vm.locationShow,"append-to-body":"","close-on-click-modal":false},on:{"close":_vm.closeDialog}},[_c('div',{staticClass:"content"},[_c('div',{ref:"map",staticClass:"mapBlock",attrs:{"id":"map"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }